import { Children, ReactNode } from 'react';
import { VerticalStepper } from '@spark-web/vertical-stepper';
import { useProtected } from './hooks';

type ProtectedStepperProps = {
  children: ReactNode;
  activeIndex: number;
  loginStepIndex: number;
};

const ProtectedStepper = ({ children, activeIndex, loginStepIndex }: ProtectedStepperProps) => {
  const totalSteps = Array.from(Children.toArray(children), (_, i) => i);

  useProtected(
    loginStepIndex,
    totalSteps.filter(s => s !== loginStepIndex),
  );

  return <VerticalStepper activeIndex={activeIndex}>{children}</VerticalStepper>;
};

export default ProtectedStepper;
